<top-navigation class="d-print-none"></top-navigation>

<main>
    <main-banner [disease]="disease"></main-banner>

    <disease-at-a-glance class="d-print-block" [id]="sections.disease.id"></disease-at-a-glance>

    <!-- What Causes This Disease? -->
    <causes class="d-print-block" [id]="sections.causes.id"></causes>

    <!-- Can This Disease Be Passed Down From Parent to Child? -->
    <inheritance class="d-print-block"></inheritance>

    <!-- At What Age Does This Disease Typically Appear? -->
    <age-at-onset class="d-print-block"></age-at-onset>

    <!-- Symptoms -->
    <symptoms-section class="d-print-block"></symptoms-section>

    <!-- Diagnostic Journey -->
    <diagnostic-journey class="d-print-block" [id]="sections.diagnosticJourney.id"></diagnostic-journey>

    <!-- Your Diagnostic Team -->
    <your-medical-team class="d-print-block"></your-medical-team>

    <div class="container-fluid disease-about-section-shadow d-print-none" aria-hidden="true">&nbsp;</div>

    <disease-multidisciplinary class="d-print-block"></disease-multidisciplinary>

    <div class="container-xxxl d-print-none">
        <hr class="m-0" />
    </div>

    <!-- Rare Disease Experts: How can you find a rare disease expert? -->
    <rare-disease-expert class="d-print-block"></rare-disease-expert>

    <div class="container-fluid disease-about-section-shadow d-print-none" aria-hidden="true">&nbsp;</div>

    <!-- Find Your Community -->
    <advocacy-and-support-groups class="d-print-block" [id]="sections.findYourCommunity.id"></advocacy-and-support-groups>

    <!-- PAG Accounts -->
    <patient-organizations-accounts class="d-print-block"></patient-organizations-accounts>

    <!-- Participating in Clinical Studies -->
    <participating-in-clinical-studies class="d-print-block" [id]="sections.clinicalStudies.id"></participating-in-clinical-studies>

    <!-- What Are Clinical Studies? -->
    <clinical-studies class="d-print-block"></clinical-studies>

    <!-- ClinicalTrials.gov -->
    <clinical-trials-contact-us class="d-print-block"></clinical-trials-contact-us>

    <div class="mb-5 d-print-none"></div>

    <app-bottom-sources-date-information class="d-print-block"></app-bottom-sources-date-information>
</main>

<app-footer></app-footer>
